import { render, staticRenderFns } from "./SignupContactDetails.vue?vue&type=template&id=01cb67c6&"
import script from "./SignupContactDetails.vue?vue&type=script&lang=js&"
export * from "./SignupContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports